/**
 * @module location
 *
 * Send and receive data from the window.location API.
 *
 * ref: https://developer.mozilla.org/en-US/docs/Web/API/Location
 */
const location = window.location;

const href = location.href;
const protocol = location.protocol;
const host = location.host;
const hostname = location.hostname;
const port = location.port;
const pathname = location.pathname;
const search = location.search;
const hash = location.hash;
const origin = location.origin;

const goto = (url) => {
  location.href = url;
};

const reload = () => {
  // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
  location.reload(true);
};

const getUrl = () => {
  return location.toString();
};

export { href, protocol, host, hostname, port, pathname, search, hash, origin, goto, reload, getUrl };
